import { createAction, props } from '@ngrx/store';

import { ActiveErrorResponse, GatewaySearch } from '@vi-iot/client';

export namespace GatewaysActions {
  export enum Type {
    LIST_GATEWAYS_SEARCH_RESULT = '[GATEWAYS] List Gateways Search Result',
    LIST_GATEWAYS_SEARCH_RESULT_SUCCESS = '[GATEWAYS] List Gateways Search Result Success',
    LIST_GATEWAYS_SEARCH_RESULT_ERROR = '[GATEWAYS] List Gateways Search Result Error',
    LIST_GATEWAYS_SEARCH_FETCH_MORE = '[GATEWAYS] List Gateways Search Fetch More Results',
    LIST_GATEWAYS_SEARCH_FETCH_MORE_SUCCESS = '[GATEWAYS] List Gateways Search Fetch More Results Success',
    LIST_GATEWAYS_SEARCH_FETCH_MORE_ERROR = '[GATEWAYS] List Gateways Search Fetch More Results Error',
    FETCH_GATEWAY_ACTIVE_ERRORS = '[GATEWAYS] Fetch Active Errors',
    FETCH_GATEWAY_ACTIVE_ERRORS_SUCCESS = '[GATEWAYS] Fetch Active Errors Success',
    FETCH_GATEWAY_ACTIVE_ERRORS_ERROR = '[GATEWAYS] Fetch Active Errors Error',
  }

  export const listGatewaysSearchResult = createAction(
    Type.LIST_GATEWAYS_SEARCH_RESULT,
    props<{
      gatewaySerial: string;
      expanded?: boolean;
      includeDevices?: boolean;
      limit?: number;
      cursor?: string;
    }>()
  );

  export const listGatewaysSearchResultSuccess = createAction(
    Type.LIST_GATEWAYS_SEARCH_RESULT_SUCCESS,
    props<{
      gateways: GatewaySearch[];
      cursor: string;
    }>()
  );

  export const listGatewaysSearchResultError = createAction(Type.LIST_GATEWAYS_SEARCH_RESULT_ERROR);

  export const listGatewaysSearchFetchMore = createAction(
    Type.LIST_GATEWAYS_SEARCH_FETCH_MORE,
    props<{
      gatewaySerial: string;
      expanded?: boolean;
      includeDevices?: boolean;
      limit?: number;
      cursor?: string;
    }>()
  );

  export const listGatewaysSearchFetchMoreSuccess = createAction(
    Type.LIST_GATEWAYS_SEARCH_FETCH_MORE_SUCCESS,
    props<{
      gateways: GatewaySearch[];
      cursor: string;
    }>()
  );

  export const listGatewaysSearchFetchMoreError = createAction(
    Type.LIST_GATEWAYS_SEARCH_FETCH_MORE_ERROR
  );

  export const FetchGatewayActiveErrors = createAction(
    Type.FETCH_GATEWAY_ACTIVE_ERRORS,
    props<{ gatewaySerial: string }>()
  );

  export const FetchGatewayActiveErrorsSuccess = createAction(
    Type.FETCH_GATEWAY_ACTIVE_ERRORS_SUCCESS,
    props<{ activeErrors: Record<string, ActiveErrorResponse[]> }>()
  );

  export const FetchGatewayActiveErrorsError = createAction(Type.FETCH_GATEWAY_ACTIVE_ERRORS_ERROR);
}
